var styles = {"olMap":"styles-module_ol-map__ufiVO","scaleContainer":"styles-module_scale-container__WgMzQ","bar":"styles-module_bar__CvJ6i","zoomContainer":"styles-module_zoom-container__VCUvr"};

export { styles as default };
//# sourceMappingURL=styles.module.css.js.map
